import React, { ChangeEvent } from "react"
import { IHandleChangeProps } from "../../../models"
import { ITax } from "../../../models/bo"
import { IFieldState } from "../../product-form/_reducers/_utils/product-form-types"
import { stringify } from "querystring"
import { Input, InputOnChangeData } from "semantic-ui-react"
import { PreviousValueMessage } from "../form-field-generator/form-field-tools"

export interface ITaxComponent {
  taxesList: ITax[]
  selectedTaxes: IFieldState<any>
  data: IFieldState<any>
  onChange: (payload: IHandleChangeProps) => void
  formId: string
  oldValue?: ITax[]
  oldValueDate: string | null
}

const TaxesField = ({
  taxesList,
  data,
  formId,
  onChange,
  selectedTaxes,
  oldValue,
  oldValueDate,
}: ITaxComponent) => {
  React.useEffect(() => {
    let currentValue: ITax[] = data.value
    if (!Array.isArray(data.value)) {
      currentValue = []
    }
    if (Array.isArray(selectedTaxes.value)) {
      const correctedData: ITax[] = []
      selectedTaxes.value.forEach((item: string) => {
        const foundOrig = taxesList.filter((tax) => tax.taxCode === item)
        const foundFilled = currentValue.filter((tax) => tax.taxCode === item)
        if (foundFilled.length <= 0) {
          foundOrig.forEach((found) => {
            correctedData.push(found)
          })
        } else {
          foundFilled.forEach((found) => {
            correctedData.push(found)
          })
        }
      })
      if (currentValue.length !== correctedData.length) {
        onChange({
          code: data.code,
          fieldValue: [...correctedData],
          lock: data.lock,
          fieldType: data.fieldType,
          forceAcceptEmptyArray: true,
        })
      }
    }
  }, [
    data.code,
    data.fieldType,
    data.lock,
    data.value,
    onChange,
    selectedTaxes.value,
    taxesList,
  ])

  const value: ITax[] = data.value
  const handleChange = React.useCallback(
    (taxCode: string, territoi: string) =>
      (event: ChangeEvent<HTMLInputElement>, d: InputOnChangeData) => {
        let val = d.value //isNaN(parseFloat(d.value)) ? 0 : parseFloat(d.value)
        const found = value.find(
          (tax) => tax.taxCode === taxCode && tax.territoi === territoi
        )

        const newValue = [
          ...value.filter(
            (tax) => tax.taxCode !== taxCode || tax.territoi !== territoi
          ),
          { ...found, value: val },
        ]

        onChange({
          code: data.code,
          fieldValue: [...newValue],
          lock: data.lock,
          fieldType: data.fieldType,
          overrideDefaultValue: true,
        })
      },
    [data.code, data.fieldType, data.lock, onChange, value]
  )

  const getTerritoiString = (territoi: string) => {
    switch (territoi) {
      case "1":
        return "FR"
      case "3":
        return "BE"
      case "4":
        return "ES"
      case "8":
        return "LU"
      default:
        return "FR"
    }
  }

  return (
    <div className="taxes-div">
      {[...value]
        .sort(
          (x, y) =>
            x.taxCode.localeCompare(y.taxCode) +
            x.territoi.localeCompare(y.territoi)
        )
        .map((tax: ITax, index: number) => {
          const ov = oldValue?.find(
            (old) =>
              old.taxCode === tax.taxCode && old.territoi === tax.territoi
          )
          const showOldValue =
            ov &&
            oldValue &&
            parseFloat(ov?.value + "") !== parseFloat(tax.value + "")

          return (
            <div key={tax.taxCode + tax.territoi}>
              <Input
                type="number"
                color="blue"
                key={tax.taxCode + tax.territoi}
                label={`[${getTerritoiString(tax.territoi)}] - ${tax.taxCode}`}
                value={tax.value}
                onChange={handleChange(tax.taxCode, tax.territoi)}
              />
              {showOldValue ? (
                <PreviousValueMessage
                  label={oldValueDate || ""}
                  content={<>{ov?.value || 0}</>}
                />
              ) : (
                ""
              )}
            </div>
          )
        })}
    </div>
  )
}

export default TaxesField
